import { createApiRef } from "@backstage/core-plugin-api";
import type { SecurityInsightsAggregatedClient } from "@internal/backstage-plugin-security-insights-common";

export const securityInsightsApiRef =
    createApiRef<SecurityInsightsAggregatedClient>({
        id: "plugin.security-insights.service",
    });
